<ngx-smart-modal #globalModal identifier="globalModal" (onDataAdded)="setData($event)" customClass="global-modal" [closable]="closeable" [escapable]="closeable" [dismissable]="closeable">
    <div *ngIf="title" class="modal-title" [innerHTML]="title"></div>
    <div *ngIf="template" class="modal-template" [innerHTML]="template"></div>
    <ng-container #modalComponentHost></ng-container>
</ngx-smart-modal>
